// Third-party
import React, { ReactNode } from 'react';
import classNames from 'classnames';

// Components
import { Tooltip } from '../tooltips';
import { HoldingIcon } from '../common';
import Nullable from '@/types/nullable';

export type LegendItem = {
  id?: string;
  label?: string;
  color?: string;
  value?: string | number;
  getLabel?: () => React.ReactNode;
  getValue?: () => React.ReactNode;
  /**
   * The tooltip to render next to the legend (could be
   * warning or info tooltip or error. See the tooltips folder for info
   * on different tooltips available)
   */
  getTooltip?: () => React.ReactNode;
  hidden?: boolean;
};

type Props = {
  items: LegendItem[];
  className?: string;
  /**
   * Disables the tooltip on the label
   */
  disableLabelTooltip?: boolean;
};

const GenericLegend = ({ items, className, disableLabelTooltip }: Props) => (
  <div className={classNames('generic-legend', className)}>
    {items.map((item, i) => {
      let value: Nullable<ReactNode> = item.value ? <span>{item.value}</span> : null;

      if (item.getValue) {
        value = item.getValue();
      }

      let label: Nullable<ReactNode> = !item.label ? null : (
        <Tooltip disabled={disableLabelTooltip} message={item.label}>
          <div className="item-label">
            {item.color && <HoldingIcon type="fund" color={item.color} />}
            <span>{`${item.label}${value ? ' :' : ''}`}</span>
          </div>
        </Tooltip>
      );

      if (item.getLabel) {
        label = item.getLabel();
      }

      return (
        <React.Fragment key={`legend-item-${i}`}>
          {label}

          {value && <div className="item-value">{value}</div>}

          {item.getTooltip && <div className="item-tooltip">{item.getTooltip()}</div>}
        </React.Fragment>
      );
    })}
  </div>
);

export default GenericLegend;
